import { API_PREFIX, API_VERSION, Command, HttpVerbType } from "../Command";
import { GetDeviceTreeReqData } from "./GetDeviceTreeReqData";
import { GetDeviceTreeResData } from "./GetDeviceTreeResData";

const ENDPOINT = "/device/tree";

export class GetDeviceTreeCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "get";
    params: GetDeviceTreeReqData = null;

    constructor(params: GetDeviceTreeReqData) {
        super();
        this.params = params;
    }

    public async execute(): Promise<GetDeviceTreeResData> {
        var res = await this.executeCommand(null, null, this.params);
        return new GetDeviceTreeResData(res);
    }
}
